<template>
  <b-modal size="lg" ref="disclaimer-modal" no-close-on-backdrop no-close-on-esc>
    <template #modal-header>
      <h5> {{ headerMessage ? headerMessage : "Diagnosestellung nicht möglich." }}</h5>
    </template>
    <b-container id="modal-container">{{ subheaderMessage ? subheaderMessage : shownText }}</b-container>
    <template #modal-footer>
      <b-button @click="$emit('noDiagnoseFoundModalConfirm')" variant="outline-danger">
        <b-icon-arrow-left-circle/>{{ confirmButtonLabel ? confirmButtonLabel : "Zurück zur Anfallsübersicht" }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>

import infoTexte from "../../js/clinical-algorithm/infoTexte/infoTexte";

export default {
  name: "NoDiagnoseFoundModal",
  props: {
    subheaderMessage: String,
    headerMessage: String,
    confirmButtonLabel: String,
    show: Boolean
  },
  emits: {
    noDiagnoseFoundModalConfirm: null
  },
  data() {
    return {
      shownText: infoTexte['modalNoDiagnoseFoundText']
    }
  },
  mounted() {
    if (this.show) {
      this.$refs["disclaimer-modal"].show()
    } else {
      this.$refs["disclaimer-modal"].hide()
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    show(newVal) {
      this.$refs["disclaimer-modal"].toggle()
    }
  }
}
</script>

<style scoped>
#modal-container {
  padding-top: 100px;
  padding-bottom: 100px;
}
</style>